import VendorSearchResultsHtml from '../../app-lite/vendors/templates/vendors.search.results.html';

export function OscarSettingsCtrl (
  $state,
  $scope,
  $translate,
  confirm,
  integrations,
  messages,
  settings,
  streamSearch,
  user,
  Vendor,
  workshopAPI
) {

  $scope.integrations = integrations;
  $scope.loaded       = true;
  $scope.settings     = settings,
  $scope.user         = user;

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'Oscar' })).then(() => {
      return workshopAPI.get('/company_integrations/add_oscar');
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'Oscar' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.deactivate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'Oscar' })).then(() => {
      return workshopAPI.get('/company_integrations/remove_oscar');
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', { name: 'Oscar' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.save = function () {
    workshopAPI.patch('/company_integrations', $scope.integrations, 'company_integration').then(() => {
      return workshopAPI.patch('/user', $scope.user, 'user');
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.vendorSearch = {
    list: [],
    selected: {
      id: $scope.integrations.oscar_vendor_id,
      company_name: $scope.settings.oscar_settings.oscar_vendor_name,
    },
    search (typed) {
      const self = this;

      return streamSearch.search('vendors', typed).then(function (vendors) {
        return self.list.concat(vendors);
      });
    },
    new () {
      const self = this;

      Vendor.quickAdd().then(vendor => {
        self.selected = vendor;

        $scope.settings.oscar_vendor_id                  = vendor.id;
        $scope.settings.oscar_settings.oscar_vendor_name = vendor.company_name;

        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', { name: 'Oscar' }), 'success');
      });
    },
    choose (vendor) {
      $scope.integrations.oscar_vendor_id              = vendor.id;
      $scope.settings.oscar_settings.oscar_vendor_name = vendor.company_name;
    },
    format (vendor) {
      return vendor ? vendor.company_name: '';
    },
    templateUrl: VendorSearchResultsHtml
  };
}